import { defineEntity, lifecycle, custom } from './_helpers.js';

export default defineEntity('vendor', {
    reviewDue: lifecycle(),
    contractExpiryReminder: custom({ scope: 'state' }),
});
